import { render } from "./Index.vue?vue&type=template&id=d58e4914"
import script from "./MainPage.js?vue&type=script&lang=js"
export * from "./MainPage.js?vue&type=script&lang=js"

import exportComponent from "/Users/sanzharzhubatkan/Sanzhar/Work/EduCenter/local-projects/educenter-update/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__